// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Kn","sizeMedium":"e_Ln","sizeSmall":"e_Mn","icon":"e_Nn"};